import React from 'react';
import './email-preview.scss';

interface EmailPreviewProps {
  html: string;
  subject?: string;
}

/**
 * Renders a preview of the exported email HTML inside a sandboxed iframe.
 */
const EmailPreview: React.FC<EmailPreviewProps> = ({ html, subject }) => {
  return (
    <div className='email-preview'>
      {subject && (
        <div className='preview-subject'>
          <strong>Onderwerp:</strong> {subject}
        </div>
      )}
      <div className='preview-frame-wrapper'>
        {html ? (
          <iframe
            title='Email Preview'
            className='preview-frame'
            srcDoc={html}
            sandbox='allow-same-origin'
          />
        ) : (
          <div className='preview-empty'>
            Klik op &quot;Voorbeeld&quot; om een preview te genereren.
          </div>
        )}
      </div>
    </div>
  );
};

export { EmailPreview };
